import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserPool,
} from "amazon-cognito-identity-js";
import { getKillSwitchInfo } from "../../store/session";
import { Input, Button, message, Row } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { updateUser } from "../../store/session";
import { usePrevious } from "../../hooks/usePrevious";
import constants from "../../configs/constants";
import app_logo from "../../assets/images/app_logo.png";

const styles = {
  container: {
    maxWidth: 300,
    marginLeft: "auto",
    marginRight: "auto",
  },
};
const Login = (props) => {
  const user = useSelector((state) => state.session.user);
  const [userName, setUserName] = useState(constants.USERNAME);
  const [password, setPassword] = useState(constants.PASSWORD);
  // const switchData = useSelector((state) => state.session.switchData);
  // const [switchMessage, setSwitchMessage] = useState();
  const [toggleSwitch, setToggleSwitch] = useState(false);
  const [screen, setScreen] = useState("");
  const dispatch = useDispatch();
  const prevUser = usePrevious(user);

  useEffect(() => {
    if (!prevUser && user) {
      // props.history.push("/atco");
    }
  }, [user]);

  // useEffect(() => {
  //   if (switchData) {
  //     console.log('switchData', switchData);
  //     if (switchData[0].status === 'ON') {
  //       setToggleSwitch(true);
  //     } else {
  //       setToggleSwitch(false)
  //     }
  //   }
  // }, [switchData]);
  useEffect(() => {
      const switchData = window.localStorage.getItem("switchStatus");
      console.log('switchData', switchData);
      if (switchData === 'ON') {
        setToggleSwitch(true);
      } else {
        setToggleSwitch(false)
      }
  }, []);

  const onUserLogin = () => {
    let sessionTokenValue = "";
    let driverAccessValue = "";
    let atcoTokenValue = "";
    let driverTokenValue = "";
    let authenticationData = {
      Username: userName,
      Password: password,
    };
    let authenticationDetails = new AuthenticationDetails(authenticationData);
    var poolData = {
      UserPoolId: constants.USERPOOLID,
      ClientId: constants.CLIENTID,
    };
    var userPool = new CognitoUserPool(poolData);
    let user = new CognitoUser({
      Username: userName,
      Pool: userPool,
    });

    const switchData = window.localStorage.getItem("switchStatus");

    if (switchData === 'ON') {
      return <Redirect to='/' />
    }

    if (switchData === 'OFF') {
      user.authenticateUser(authenticationDetails, {
        onFailure: (err) => {
          console.log(err);
          message.error(err.message);
        },
        onSuccess: (result) => {
  
          let sessionStorageValue = "";
          try {
            // atco page
            if (result.idToken.payload["custom:role"] == "atco") {
              sessionStorageValue = result.accessToken.payload["cognito:groups"][0] + "," + result.idToken.payload.name;
  
              //set values
              sessionTokenValue = result.accessToken.jwtToken;
              atcoTokenValue = result;
              //set session storage
              sessionStorage.setItem("pbrsession", sessionStorageValue);
  
              //set local sotrage
              window.localStorage.setItem("accessToken", sessionTokenValue);
              window.localStorage.setItem("atcoToken", JSON.stringify(atcoTokenValue));
  
  
              console.log("LOGIN ATCO PAGE");
            } else {
              // driver page
  
              //set values
              driverAccessValue = result.accessToken.jwtToken;
              driverTokenValue = result;
  
              //set local sotrage
              window.localStorage.setItem("driverAccessToken", driverAccessValue);
              window.localStorage.setItem("driverToken", JSON.stringify(driverTokenValue));
              dispatch(getKillSwitchInfo({message: 'getS3Message'}));
              console.log('switch message call 1')
  
              // check if there is already a switch status
              // if (window.localStorage.getItem("switchStatus")) {
              //   let value = window.localStorage.getItem("switchStatus")
              //   window.localStorage.setItem(
              //     "switchStatus",
              //     value
              //   );
              // } else {
              //   window.localStorage.setItem(
              //     "switchStatus",
              //     'OFF'
              //   );
              // }
              
              
  
              //set session storage
              // sessionStorage.setItem("driverSession", JSON.stringify(driverTokenValue));
  
              console.log("LOGIN DRIVER PAGE");
            }
          } catch (error) {
            console.log("session :" + error);
          }
  
          if (result.idToken.payload["custom:role"] === "atco") {
            dispatch(updateUser(result));
            return <Redirect to='/atco' />
          }
  
          if (result.idToken.payload["custom:role"] === "driver") {
            dispatch(updateUser(result));
            return <Redirect to='/driver' />
          }
  
          // if (result.idToken.payload["custom:role"] === "atco" && !toggleSwitch) {
          //   dispatch(updateUser(result));
          //   console.log('con 1')
          //   return <Redirect to='/atco' />
          // } else if (result.idToken.payload["custom:role"] === "driver" && !toggleSwitch) {
          //   dispatch(updateUser(result));
          //   console.log('con 2')
          //   return <Redirect to='/driver' />
          // } else if (result.idToken.payload["custom:role"] === "atco" && toggleSwitch){
          //   console.log('con 3')
          //   return <Redirect to='/' />
          // }
  
  
  
        },
      });
    }

    
  };

  return (
    <div style={styles.container}>
      <div style={{ paddingTop: 100, paddingBottom: 50, textAlign: "center" }}>
        <Row type="flex" justify="center">
          <img src={app_logo} alt="app_logo" style={{ width: 200, height: "100%" }} />
        </Row>
      </div>
      <Input
        style={{ marginBottom: 20 }}
        placeholder="username"
        value={userName}
        onChange={(e) => setUserName(e.target.value)}
        onPressEnter={() => { onUserLogin() }}
      />

      <Input.Password
        style={{ marginBottom: 20 }}
        placeholder="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        onPressEnter={() => { onUserLogin() }}
      />
      <Button type="primary" style={{ width: "100%" }} onClick={onUserLogin}>
        Login
      </Button>
    </div>
  );
};

export default Login;
